// ---------------------------------------------------------------
// Broker accounts + session + fleet. A broker signs up, logs in, and builds a
// fleet by adding cars with the per-car share code the owner gives them.
// Stored locally for now (moves to the backend/auth service at launch — this is
// not secure credential storage, it's a working client-side model).
// ---------------------------------------------------------------
import { API_BASE } from './config';

const B_KEY = 'ta-brokers';
const S_KEY = 'ta-broker-session';
const ME_KEY = 'ta-broker-me'; // cached identity in backend mode

const PROXY = !!API_BASE;
const load = () => { try { return JSON.parse(localStorage.getItem(B_KEY)) || []; } catch { return []; } };
const save = (a) => localStorage.setItem(B_KEY, JSON.stringify(a));
const cacheMe = (u) => { try { if (u) localStorage.setItem(ME_KEY, JSON.stringify(u)); else localStorage.removeItem(ME_KEY); } catch { /* ignore */ } };
const setJwt = (t) => { try { if (t) localStorage.setItem('ta-jwt', t); else localStorage.removeItem('ta-jwt'); } catch { /* ignore */ } };
// simple non-cryptographic hash — placeholder used only in local (no-backend) mode
const hash = (s) => { let h = 5381; for (let i = 0; i < s.length; i++) { h = ((h << 5) + h + s.charCodeAt(i)) >>> 0; } return h.toString(36); };

export function getBrokers() { return load(); }

export async function createBroker({ name, company, email, password }) {
  const e = (email || '').toLowerCase().trim();
  if (!e || !password) throw new Error('Email and password are required.');
  if (PROXY) {
    const r = await fetch(`${API_BASE}/auth/broker/signup`, { method: 'POST', credentials: 'include', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ name, company, email: e, password }) });
    if (!r.ok) { const d = await r.json().catch(() => ({})); throw new Error(d.error || 'Could not create the account.'); }
    const u = await r.json(); cacheMe(u); setJwt(u.token); return u;
  }
  const list = load();
  if (list.some((b) => b.email === e)) throw new Error('An account with that email already exists.');
  const rec = { id: `B${Date.now()}`, name: name || '', company: company || '', email: e, pass: hash(password), fleet: [], createdAt: new Date().toISOString() };
  list.push(rec); save(list);
  localStorage.setItem(S_KEY, rec.id);
  return rec;
}

export async function brokerLogin(email, password) {
  const e = (email || '').toLowerCase().trim();
  if (PROXY) {
    const r = await fetch(`${API_BASE}/auth/broker/login`, { method: 'POST', credentials: 'include', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ email: e, password }) });
    if (!r.ok) { const d = await r.json().catch(() => ({})); throw new Error(d.error || 'Wrong email or password.'); }
    const u = await r.json(); cacheMe(u); setJwt(u.token); return u;
  }
  const b = load().find((x) => x.email === e);
  if (!b || b.pass !== hash(password)) throw new Error('Wrong email or password.');
  localStorage.setItem(S_KEY, b.id);
  return b;
}

export function brokerLogout() {
  if (PROXY) { try { fetch(`${API_BASE}/auth/logout`, { method: 'POST', credentials: 'include' }); } catch { /* ignore */ } cacheMe(null); setJwt(''); return; }
  localStorage.removeItem(S_KEY);
}

export function getBrokerSession() {
  if (PROXY) { try { return JSON.parse(localStorage.getItem(ME_KEY)); } catch { return null; } }
  const id = localStorage.getItem(S_KEY);
  if (!id) return null;
  return load().find((b) => b.id === id) || null;
}

export function addToFleet(brokerId, deviceId) {
  const list = load(); const b = list.find((x) => x.id === brokerId);
  if (b && !b.fleet.includes(deviceId)) { b.fleet.push(deviceId); save(list); }
  return b;
}
export function removeFromFleet(brokerId, deviceId) {
  const list = load(); const b = list.find((x) => x.id === brokerId);
  if (b) { b.fleet = b.fleet.filter((id) => id !== deviceId); save(list); }
  return b;
}
export function getFleetIds(brokerId) {
  const b = load().find((x) => x.id === brokerId);
  return b ? b.fleet : [];
}
